<div class="main-content table-page table-page--compact table-page--dense mi-plan-page">
  <div class="container-fluid">
    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1>Mi plan</h1>
        <p>Dónde va a trabajar los próximos días; solo declare las excepciones.</p>
      </div>
      <div class="table-page__toolbar-actions">
        <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary"
                (click)="semanaAnterior()">
          <span class="material-icons">chevron_left</span>
          Semana anterior
        </button>
        <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary"
                (click)="semanaSiguiente()">
          Semana siguiente
          <span class="material-icons">chevron_right</span>
        </button>
      </div>
    </section>

    <section class="table-page__card">
      <div class="mi-plan-page__rejilla" *ngIf="!loading">
        <article class="mi-plan-page__dia" *ngFor="let dia of dias"
                 [class.mi-plan-page__dia--pasado]="dia.esPasado"
                 [class.mi-plan-page__dia--declarado]="dia.plan">
          <header class="mi-plan-page__dia-encabezado">
            <span class="mi-plan-page__dia-semana">{{ dia.diaSemana }}</span>
            <span class="mi-plan-page__dia-numero">{{ dia.etiqueta }}</span>
          </header>

          <div class="mi-plan-page__opciones" *ngIf="!dia.esPasado">
            <button type="button" class="mi-plan-page__opcion"
                    [class.mi-plan-page__opcion--activa]="esActiva(dia, 'OFICINA')"
                    (click)="declarar(dia, 'OFICINA')">
              <span class="material-icons">business</span>
              Oficina
            </button>
            <button type="button" class="mi-plan-page__opcion"
                    [class.mi-plan-page__opcion--activa]="esActiva(dia, 'HOME_OFFICE')"
                    (click)="declarar(dia, 'HOME_OFFICE')">
              <span class="material-icons">home</span>
              Casa
            </button>
          </div>

          <p class="mi-plan-page__heredado" *ngIf="dia.esPasado && !dia.plan">Sin declarar</p>
          <p class="mi-plan-page__heredado" *ngIf="dia.esPasado && dia.plan">
            {{ nombreModalidad(dia.plan.modalidadAm) }}
          </p>

          <div class="mi-plan-page__sitio" *ngIf="dia.plan && !dia.esPasado && dia.plan.modalidadAm === 'OFICINA'">
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Sitio</mat-label>
              <mat-select [ngModel]="dia.plan.idUbicacion" (ngModelChange)="cambiarSitio(dia, $event)">
                <mat-option *ngFor="let sitio of ubicaciones" [value]="sitio.id">{{ sitio.nombre }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <footer class="mi-plan-page__dia-pie" *ngIf="dia.plan">
            <span class="mi-plan-page__origen">{{ etiquetaOrigen(dia.plan) }}</span>
            <button type="button" class="mi-plan-page__quitar" *ngIf="!dia.esPasado" (click)="quitar(dia)">
              <span class="material-icons">undo</span>
              Quitar
            </button>
          </footer>
        </article>
      </div>

      <div class="table-page__empty table-page__empty--loading" *ngIf="loading">
        <span class="material-icons">hourglass_top</span>
        <h3>Consultando su plan</h3>
        <p>Espere un momento.</p>
      </div>
    </section>
  </div>
</div>
